import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import CustomerGroup4ManagementColumnModel from './customer-group4-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const CustomerGroup4ManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Customer Group 4 Management";
  //   },[]); 
    useDocumentTitle(); 
  return (
    <CommonTablePage
      urlInfoKey={urlKey.CustomerGroup4}
      title="Customer Group 4 Management"
      column={CustomerGroup4ManagementColumnModel.CustomerGroup4ManagementColumn}
    />
  )
}

export default CustomerGroup4ManagementPage
